import config from '../../../config/config';

export const SUBMIT_PRE_VET_FORM = 'SUBMIT_PRE_VET_FORM';
export const SUBMIT_PRE_VET_FORM_SUCCESS = 'SUBMIT_PRE_VET_FORM_SUCCESS';
export const SUBMIT_PRE_VET_FORM_FAILURE = 'SUBMIT_PRE_VET_FORM_FAILURE';
export const CLEAR_PRE_VET_FORM_ERROR = 'CLEAR_PRE_VET_FORM_ERROR';
export const RESET_PRE_VET_FORM = 'RESET_PRE_VET_FORM';
export const SUBMIT_PRE_VET_FORM_LOADING = 'SUBMIT_PRE_VET_FORM_LOADING';

export const UPDATE_PREVET_FORM = 'UPDATE_PREVET_FORM';
export const UPDATE_PREVET_FORM_LOADING = 'UPDATE_PREVET_FORM_LOADING';
export const UPDATE_PREVET_FORM_SUCCESS = 'UPDATE_PREVET_FORM_SUCCESS';
export const UPDATE_PREVET_FORM_FAILURE = 'UPDATE_PREVET_FORM_FAILURE';

export function submitPrevetForm(formData) {
    return {
        failureActionTypeOrCreator: submitPrevetFormFailure,
        fetchParams: {
            method: 'POST',
            url: `${config.underwritingApiUrl}/prevet`,
            body: formData,
            shouldStringifyBody: false
        },
        loadActionTypeOrCreator: SUBMIT_PRE_VET_FORM,
        successActionTypeOrCreator: submitPrevetFormSuccess
    };
}

export function submitPrevetFormSuccess(response) {
    return {
        type: SUBMIT_PRE_VET_FORM_SUCCESS,
        response: response
    };
}

export function submitPrevetFormFailure(error) {
    return {
        error,
        type: SUBMIT_PRE_VET_FORM_FAILURE
    };
}

export function clearPrevetFormError() {
    return {
        type: CLEAR_PRE_VET_FORM_ERROR
    };
}

export function resetPrevetForm() {
    return {
        type: RESET_PRE_VET_FORM
    };
}

export function submitPrevetFormLoading() {
    return {
        type: SUBMIT_PRE_VET_FORM_LOADING
    };
}

export function updatePrevetFormSuccessActionCreator(response) {
    return {
        response: response,
        type: UPDATE_PREVET_FORM_SUCCESS
    };
}

export function updatePrevetFormLoading() {
    return {
        type: UPDATE_PREVET_FORM_LOADING
    };
}

export function updatePrevetFormFailureActionCreator(error) {
    return {
        error,
        type: UPDATE_PREVET_FORM_FAILURE
    };
}

export function onSubmitEditPrevetForm(prevetId, data) {
    return {
        failureActionTypeOrCreator: updatePrevetFormFailureActionCreator,
        fetchParams: {
            url: `${config.underwritingApiUrl}/prevet/${prevetId}`,
            method: 'PUT',
            body: data,
            shouldStringifyBody: false
        },
        loadActionTypeOrCreator: UPDATE_PREVET_FORM,
        successActionTypeOrCreator: updatePrevetFormSuccessActionCreator
    };
}
